import { defineComponent as _defineComponent } from 'vue'
import { BaseIcon, BadgeCounterFoundation } from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardCounter',
  props: {
    badgeCounter: null,
    label: null,
    icon: null,
    disabled: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  badgeCounter?: number;
  label: string;
  icon: string;
  disabled?: boolean;
}




const computedClass = (className: string) => {
  return {
    [className]: true,
    [`${className}--disabled`]: props.disabled
  };
};

const handleClick = async () => {
  if (!props.disabled) {
    emit('click');
  }
};

return { __sfc: true,emit, props, computedClass, handleClick, BaseIcon, BadgeCounterFoundation }
}

})